import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, TreeStructure, Folder, Desktop, Scroll, UserCircle } from "@phosphor-icons/react";
import { EmployeeDirectory } from "./EmployeeDirectory";
import { OrgChart } from "./OrgChart";
import { DocumentVault } from "./DocumentVault";
import { AssetRegistry } from "./AssetRegistry";
import { AuditLogs } from "./AuditLogs";

export function CoreHRDashboard() {
  const [activeTab, setActiveTab] = useState("directory");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Core HR & PIM
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Centralized employee data, documents, and assets management.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2 md:grid-cols-5 lg:w-auto">
          <TabsTrigger value="directory" className="gap-2">
            <Users className="w-4 h-4" />
            <span className="hidden md:inline">Directory</span>
          </TabsTrigger>
          <TabsTrigger value="org-chart" className="gap-2">
            <TreeStructure className="w-4 h-4" />
            <span className="hidden md:inline">Org Chart</span>
          </TabsTrigger>
          <TabsTrigger value="documents" className="gap-2">
            <Folder className="w-4 h-4" />
            <span className="hidden md:inline">Documents</span>
          </TabsTrigger>
          <TabsTrigger value="assets" className="gap-2">
            <Desktop className="w-4 h-4" />
            <span className="hidden md:inline">Assets</span>
          </TabsTrigger>
          <TabsTrigger value="audit" className="gap-2">
            <Scroll className="w-4 h-4" />
            <span className="hidden md:inline">Audit Logs</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="directory" className="space-y-4">
            <EmployeeDirectory />
          </TabsContent>

          <TabsContent value="org-chart" className="space-y-4">
            <OrgChart />
          </TabsContent>

          <TabsContent value="documents" className="space-y-4">
            <DocumentVault />
          </TabsContent>

          <TabsContent value="assets" className="space-y-4">
            <AssetRegistry />
          </TabsContent>

          <TabsContent value="audit" className="space-y-4">
            <AuditLogs />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
